import React, { useRef, useState, useEffect } from "react"
import { Box, Image as ThemeUiImage } from "theme-ui"
import HomeHeader from "./homeHeader"
import HomeAboutUsPartOne from "./homeAboutUsPartOne"
import HomeAboutUsPartTwo from "./homeAboutUsPartTwo"
import HomeFocusSection from "./homeFocusSection"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"
import CityImage from "../images/city/Citta200.png"
import { useBreakpointIndex } from "@theme-ui/match-media"

gsap.registerPlugin(ScrollTrigger)

const HomeAnimationSection = ({ block, animationImages }) => {
  const { sections } = block
  const pinned = useRef(null)
  const canvasRef = useRef(null)
  const pieceContainerRef = useRef(null)
  const animationContainer = useRef()
  const [images, setImages] = useState([])
  const [canvasLoaded, setCanvasLoaded] = useState(false)
  const [frameIndex, setFrameIndex] = useState(0)
  const frameCount = 69
  const handleGetCurrentFrame = index => {
    return animationImages.edges[index].node.publicURL
  }

  const scrollListener = event => {
    var s = document.querySelector("#home_animation_section")
    if (s) {
      var offsets = s.offsetHeight
      let hundredVh = Math.round(window.innerHeight / (100 / 100))
      if (pinned.current)
        pinned.current.style.top = offsets - hundredVh - window.scrollY + "px"
    }
  }

  const preloadImages = () => {
    let tmpImages = []
    for (let i = 0; i <= frameCount - 1; i++) {
      const img = new Image()
      const imgSrc = handleGetCurrentFrame(i)
      img.src = imgSrc
      tmpImages.push(img)
    }

    setImages(tmpImages)
  }

  const renderCanvas = () => {
    window.scrollBy({ top: 1, behavior: "smooth" })
    const context = canvasRef.current.getContext("2d")
    context.canvas.width = 1000
    context.canvas.height = 1000

    setTimeout(() => {
      setCanvasLoaded(true)
    }, 200)
  }

  useEffect(() => {
    preloadImages()
    renderCanvas()

    var s = document.querySelector("#home_animation_section")
    var globalScrollTop = window.scrollY
    var offsets = s.offsetHeight
    let scroll = window.scrollY
    let hundredVh = Math.round(window.innerHeight / (100 / 100))

    if (pinned.current && offsets - hundredVh - window.scrollY < 0)
      pinned.current.style.top = offsets - hundredVh - window.scrollY + "px"
  }, [])

  useEffect(() => {
    var nLast = document.querySelector(
      `.home__animation_section_${sections.length - 1}`
    )
    var sectionsElements = document.querySelectorAll(
      ".home__animation_sections_"
    )
    var nFirst = document.querySelector(`.home__animation_section_0`)

    if (!canvasRef.current || images.length < 1) {
      return
    }

    const products = {
      frame: 0,
    }

    const handleRender = () => {
      if (canvasRef.current) {
        const canvasContext = canvasRef.current.getContext("2d")
        const canvasEl = canvasRef.current
        canvasContext.clearRect(0, 0, canvasEl.width, canvasEl.height)
        canvasContext.drawImage(
          images[products.frame],
          canvasEl.width / 2 - images[products.frame].width / 2,
          canvasEl.height / 2 - images[products.frame].height / 2
        )
      }
    }

    gsap.set(".piece_container", {
      xPercent: "-16",
      yPercent: "-12",
    })

    gsap.set(".city_container", {
      xPercent: "-22",
      yPercent: "1.7",
      opacity: 1,
    })

    gsap.to(".piece_container", {
      xPercent: "-45",
      yPercent: "0",
      duration: 3,
      scrollTrigger: {
        trigger: document.querySelector(".home__animation_section_1"),
        toggleActions: "none pause reverse pause",
        start: "top top+=100%",
        end: "bottom bottom",
        scrub: true,
      },
    })

    gsap.to(".city_container", {
      alpha: 0,
      ease: "ease-in-out",
      duration: 0.3,
      opacity: 0,
      scrollTrigger: {
        trigger: document.querySelector(".home__animation_section_1"),
        toggleActions: "none pause reverse pause",
        start: "top top+=100%",
        end: "top top+=85%",
        scrub: true,
      },
    })

    gsap.to(products, {
      id: "piece_container",
      frame: frameCount - 1,
      snap: "frame",
      scrollTrigger: {
        scrub: 0.2,
        start: "top top",
        end: "bottom bottom",
        endTrigger: document.querySelector(".home__animation_section_3"),
        onLeave: function (e) {
          window.addEventListener("scroll", scrollListener)
        },
        onEnterBack: function (e) {
          if (pinned.current) {
            window.removeEventListener("scroll", scrollListener)
            pinned.current.style.top = 0 + "px"
          }
        },
      },
      onUpdate: handleRender,
    })

    images[0].onload = handleRender
  }, [frameIndex, images])

  return (
    <Box
      ref={animationContainer}
      sx={{
        zIndex: 999,
        overflow: "hidden",
        position: "relative",
        backgroundColor: "primary",
      }}
    >
      <Box
        ref={pinned}
        className="pinned"
        sx={{
          opacity: canvasLoaded ? 1 : 0,
          transition: "opacity .2s ease",
          // "&.loaded": {
          //   opacity: "1",
          // },
          visibility: "inherit",
          display: ["none", "none", "-webkit-flex", "flex"],
          position: "fixed",
          top: "0",
          left: "0",
          WebkitAlignItems: "center",
          alignItems: "center",
          WebkitJustifyContent: "center",
          justifyContent: "center",
          zIndex: 400,
          width: "100vw",
          height: "100vh",
          pointerEvents: "none",
          willChange: "top,transform",
        }}
      >
        <Box
          className="piece_container"
          id="piece_container"
          ref={pieceContainerRef}
          sx={{
            width: ["60vw", "max(220px,60vw)"],
            height: ["60vw", "max(220px,60vw)"],
          }}
        >
          <Box
            as="canvas"
            ref={canvasRef}
            className={canvasLoaded ? "loaded" : ""}
            sx={{
              position: "absolute",
              zIndex: 200,
              background: "transparent",
              width: ["60vw"],
              height: ["60vw"],
              pointerEvents: "none",
            }}
          />
        </Box>
        <Box
          className={canvasLoaded ? "loaded city_container" : "city_container"}
          sx={{
            width: ["60vw", "max(220px,60vw)"],
            height: ["60vw", "max(220px,60vw)"],
            position: "absolute",
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              zIndex: 201,
              background: "transparent",
              width: ["70vw", "max(220px,70vw)"],
              height: ["70vw", "max(220px,70vw)"],
              pointerEvents: "none",
            }}
          >
            <ThemeUiImage src={CityImage} />
          </Box>
        </Box>
      </Box>
      {sections &&
        sections.map((section, index) => (
          <Box
            as="section"
            key={section.id}
            className={
              "home__animation_section home__animation_section_" + index
            }
            sx={{
              position: "relative",
              minHeight: ["374px", "474px", "764px", "764px"],
              height: ["auto", "auto", "100vh"],
              pr: "0!important",
              zIndex: 0,
            }}
          >
            {section.model.apiKey === "home_header" && (
              <HomeHeader block={section} />
            )}
            {section.model.apiKey === "home_about_us_part1" && (
              <HomeAboutUsPartOne block={section} />
            )}
            {section.model.apiKey === "home_about_us_part2" && (
              <HomeAboutUsPartTwo block={section} />
            )}
            {section.model.apiKey === "home_focus_section" && (
              <HomeFocusSection block={section} />
            )}
          </Box>
        ))}
    </Box>
  )
}

export default HomeAnimationSection
